@import '../../styles/palette.scss';
@import '../../styles/fonts.scss';
@import './mixins.scss';

.textInputContainer {
  @include barlow(16);
  display: inline-grid;
  width: 100%;

  &,
  * {
    box-sizing: border-box;
  }

  .textInputLabel {
    color: _palette(text-primary);

    label {
      display: block;
      margin: 0.125rem 0 0.3125rem 0;
    }

    & > input {
      @include inputPadding();
    }

    &:hover {
      & > label {
        color: _palette(secondary);
      }

      & > input {
        &:not(:disabled):not(.hideBorder) {
          @include largeBorderInputPadding();
          border: $border-width-thick solid _palette(secondary);
        }
      }
    }

    .required {
      color: _palette(text-red);
      font-weight: 600;
    }

    &.disabled {
      label {
        color: _palette(text-secondary);
      }
    }
  }

  .textInput {
    background-color: _palette(bg-secondary);
    border: $border-width solid _palette(black-25);
    border-radius: 5px;
    color: _palette(text);
    font-size: 1rem;
    outline: none;
    width: 100%;
    height: $inputHeight;

    &.hideBorder {
      border: $border-width solid transparent;
    }

    &.highlighted {
      border: $border-width-thick solid _palette(secondary);
    }

    &:disabled {
      color: _palette(text-secondary);

      &:not(.hideBorder) {
        border: $border-width solid _palette(text-disabled);
      }
    }

    &:focus {
      border: $border-width-thick solid _palette(secondary);
      box-shadow:
        0 0 2px 0 rgba(15, 106, 136, 0.12),
        0 4px 4px 0 rgba(15, 106, 136, 0.24);

      &:not(:disabled):not(.hideBorder) {
        @include largeBorderInputPadding();
        border: $border-width-thick solid _palette(secondary);
      }
    }
  }
}
